module.exports = __webpack_public_path__ + "img/HZ-P1008.6cab668a.jpg";